/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Home_H1Inputs */

const en_wc_home_h1 = /** @type {(inputs: Wc_Home_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WordCraft: write online or download for desktop.`)
};

/**
* | output |
* | --- |
* | "WordCraft: write online or download for desktop." |
*
* @param {Wc_Home_H1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_home_h1 = /** @type {((inputs?: Wc_Home_H1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Home_H1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_home_h1(inputs)
});
export { wc_home_h1 as "wc.home.h1" }